import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmTextareaComponent } from './sm-textarea.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SmErrorModule } from '../sm-error/sm-error.module';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';



@NgModule({
    declarations: [SmTextareaComponent],
    imports: [CommonModule, FormsModule, SmErrorModule, ReactiveFormsModule, AngularEditorModule],
    exports: [SmTextareaComponent]
})
export class SmTextareaModule {}


